import { useCallback, useEffect, useState } from 'react';
import api from '../../utils/api';

const ROOT = '/admin/holiday-world/assignees';

export const errorText = err => typeof err?.response?.data?.detail === 'string' ? err.response.data.detail : 'Operazione non riuscita. Riprova.';
export const AUDIENCES = { partner: 'Partner', proprietario: 'Proprietario' };
export const STATES = {
  da_assegnare: 'Da assegnare', assegnato: 'Assegnato · entro 48 ore', attende_esito: 'Promemoria inviato · attende esito',
  interessato: 'Interessato', non_interessato: 'Non interessato', non_contattato: 'Non contattato · da riassegnare', in_attesa: 'In attesa di risposta',
};
export const STATE_STYLES = {
  da_assegnare: 'bg-slate-100 text-slate-700', assegnato: 'bg-blue-50 text-blue-800', attende_esito: 'bg-amber-50 text-amber-800',
  interessato: 'bg-emerald-50 text-emerald-800', non_interessato: 'bg-rose-50 text-rose-800', non_contattato: 'bg-orange-100 text-orange-900', in_attesa: 'bg-sky-50 text-sky-800',
};
export const MAIL = { sent: 'Mail inviata', failed: 'Mail non partita', sending: 'Invio in corso' };
export const when = value => value ? new Date(value).toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'short' }) : '—';

export const useAssignees = enabled => {
  const [assignees, setAssignees] = useState([]), [error, setError] = useState('');
  const load = useCallback(() => api.get(ROOT).then(({ data }) => { setAssignees(data); setError(''); })
    .catch(() => setError('Impossibile caricare le persone incaricate.')), []);
  useEffect(() => { if (enabled) load(); }, [enabled, load]);
  const save = async (form, id) => {
    const { data } = id ? await api.put(`${ROOT}/${id}`, form) : await api.post(ROOT, form);
    await load();
    return data;
  };
  return { assignees, error, save, reload: load };
};
